import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { messaging } from "JS/Helpers/UserMessaging";
import { MediaEssentials } from "JS/Models/MediaEssentials";

export const initialState: MediaEssentials = {
    allow_rule_engine_requests: true,
    allow_seamless_update_react: true,
    has_event_started: false,
    download_warning_count: 1,
    download_warning_msg: messaging.mediaEssentials.downloadWarningMsg,
    download_warning_cleared_on_logout: true,
    allow_fetch_team_status: true,
    allow_fyc_status_request: true,
    allow_speaker_feature: true,
    allow_consent_form_feature: true,
    player_progress_interval_courses: 2000,
    purchase_bundle_sso_redirection_place: "",
    user_subscriptions_for_purchase_bundle: [],
    enable_pinpoint: false,
    allow_disclosure_feature: false,
};

export const mediaEssentialsStateSlice = createSlice({
    name: "mediaEssentialsState",
    initialState,
    reducers: {
        setGlobalMediaEssentials: (
            state,
            data: PayloadAction<MediaEssentials>,
        ) => {
            state.allow_rule_engine_requests =
                data.payload?.allow_rule_engine_requests;
            state.allow_seamless_update_react =
                data.payload?.allow_seamless_update_react;
            state.has_event_started = data.payload?.has_event_started;
            state.download_warning_count = data.payload?.download_warning_count;
            state.download_warning_msg = data.payload?.download_warning_msg;
            state.download_warning_cleared_on_logout =
                data.payload?.download_warning_cleared_on_logout;
            state.allow_fetch_team_status =
                data.payload?.allow_fetch_team_status;
            state.allow_fyc_status_request =
                data.payload?.allow_fyc_status_request;
            state.allow_speaker_feature = data.payload?.allow_speaker_feature;
            state.player_progress_interval_courses =
                data.payload?.player_progress_interval_courses;
            state.missing_consent_member_ids =
                data.payload?.missing_consent_member_ids;
            state.purchase_bundle_sso_redirection_place =
                data.payload?.purchase_bundle_sso_redirection_place;
            state.user_subscriptions_for_purchase_bundle =
                data.payload?.user_subscriptions_for_purchase_bundle;
            state.enable_pinpoint =
                data.payload?.enable_pinpoint ?? initialState.enable_pinpoint;
            // this reducer copies named fields, so a new flag is off until listed here
            state.allow_disclosure_feature =
                data.payload?.allow_disclosure_feature ??
                initialState.allow_disclosure_feature;
            state.disclosure_unavailable_msg =
                data.payload?.disclosure_unavailable_msg;
            return state;
        },
        resetMediaEssentials: () => {
            return initialState;
        },
    },
});
export const { setGlobalMediaEssentials, resetMediaEssentials } =
    mediaEssentialsStateSlice.actions;
